 import { styled } from "@mui/material/styles";

 const StyledSettings = styled("div")(
  ({ theme }) => `
  .settings-container {
    margin: 50px 30%;
  }
  .settings-header {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .settings-title {
    font-family: Lexend;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;
    color: ${theme.palette.primary.secondary};
  }
  .recovery-email-wrap {
    border: 1px solid ${theme.palette.customColor.secondaryThird};
    border-radius: 0px;
    padding: 20px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .recovery-email-icon-text-wrap {
    display: flex;
    gap: 10px;
    align-items: flex-start;
  }
  .recovery-email-body {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }  
  .recovery-email-title {
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${theme.palette.primary.secondary};
  }
  .recovery-email-text {
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: ${theme.palette.customColor.secondarySecond};
  }
  .recovery-add-email-btn {
    border: 1px solid ${theme.palette.primary.main};
    color: ${theme.palette.primary.main};
    text-transform: none;
    border-radius: 0px;
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    height: 30px;
  }
  .delete-account-wrap {
    border: 1px solid ${theme.palette.customColor.secondaryThird};
    border-radius: 0px;
    padding: 20px;
    margin-top: 20px;
    display: flex;
    gap: 10px;
    align-items: start;
    cursor: pointer;
  }
  .delete-account-body {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }               
  .delete-account-title {
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: ${theme.palette.primary.secondary};
  }
  .delete-account-text {
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    color: ${theme.palette.customColor.secondarySecond};
  }
  .recovery-update-email-btn {
    background-color: ${theme.palette.secondary.main};
    color: ${theme.palette.customColor.white};
    text-transform: none;
    border-radius: 0px;
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 100%;
    height: 30px;
  }
  .recovery-email-textfield {
    margin-top: -10px;
  }           
  ` )
  export default StyledSettings;
